import React, { useContext } from 'react'
import './DashboardLeaveReq.css'
import Profile from '../../../../Assets/DashboardImages/profile.png'
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import EmployeeLeaveCard from './EmployeeLeaveCard/EmployeeLeaveCard';
import { formatDate } from '../../../../utils/formatDate';
import { useNavigate } from 'react-router-dom';
import { dashboardContext } from '../../Dashboard';
import CustomSkelton from '../../../../Components/Skeletons/CustomSkelton';
function DashboardLeaveReq({ title }) {
    const navigate = useNavigate()
    const { data, isLoading } = useContext(dashboardContext);

    const handleNavigate = () => {
        navigate(`/leave/leave/list`)
    }


    return (
<>
  <div className='dashboard-mid-section'>

            <div className='dashboard-title-container'>
                <span className='dashboard-title'>{title}</span>
                <div className='dashboard-view-all-container'>
                    <span onClick={handleNavigate} style={{ cursor: 'pointer', color: '#0066CC', fontWeight: '600' }}>View All</span>

                    {/* <ActionButton label={'View All'}  onClick={handleNavigate} />  */}
                    {/* btnType={'primary'} */}
                </div>
            </div>


            <div className='dashboard-sub-container'>
                {data?.leaves?.length === 0 || data?.leaves === undefined ? (
                    <div className='no-data-message'>No Leaves Found</div>
                ) : <>
                    {data?.leaves?.map((leave) => (
                        <EmployeeLeaveCard
                            key={leave.id}
                            name={leave?.Employeename || 'N/A'}
                            leaveStatus={leave?.leaveStatus || 'N/A'}
                            leaveStatusId={leave?.leaveStatusID || 'N/A'}
                            leaveType={leave?.leave_type || 'N/A'}
                            startDate={leave?.start_date || 'N/A'}
                            endDate={leave?.end_date || 'N/A'}
                        />
                    ))}
                </>}

            </div>


        </div>

</>

      
    )
}

export default DashboardLeaveReq

